export default __webpack_public_path__ + "static/media/Background_00027.c0c501d1.png";